<template>
  <CRow>
    <CCol>
      <CCard>
        <CCardHeader>Create Author</CCardHeader>
        <CCardBody>
          <CRow class="form-group">
            <CCol :col="9">
              <CInput
                  v-model="authorForm.author_name"
                  label="Nama"
                  class="mb-0"
                  type="text"
                  required
                  horizontal
                  placeholder="Title"
                  @change="handleCorporateActionTitle"
              />
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="9">
              <CInput
                  id="corporate_slug"
                  v-model="authorForm.author_slug"
                  label="Slug"
                  class="mb-0"
                  type="text"
                  required
                  horizontal
                  placeholder="Url Name"
                  @change="handleCorporateActionSlug"
              />
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="9">
              <CInput
                  label="Deskripsi"
                  class="mb-0"
                  type="text"
                  required
                  horizontal
                  placeholder="Author Description"
                  @change="handleAuthorDescription"
              />
            </CCol>
          </CRow>
           <CRow class="form-group">
            <CCol :col="9">
              <CInputFile
                  label="Banner Desktop"
                  horizontal
                  type="file"
                  :isValid="false"
                  :invalidFeedback="error.author_banner.message"
                  @change="handleCorporateActionBannerUrl"
              >
               <template v-slot:label-after-input>
                  File size should be below 2MB and Optimize picture size is 1440px x 800px.
                </template>
              </CInputFile>
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="9">
              <img class="image-ilustrasi" id="myImg" v-if="bannerUrl && !error.author_banner.message" :src="bannerUrl"/>
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="9">
              <CInputFile
                  label="Banner Mobile"
                  horizontal
                  type="file"
                  :isValid="false"
                  :invalidFeedback="error.author_banner_mobile.message"
                  @change="handleCorporateActionBannerMobileUrl"
              >
               <template v-slot:label-after-input>
                  File size should be below 2MB and Optimize picture size is 360px x 640px.
                </template>
              </CInputFile>
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="9">
              <img class="image-ilustrasi" id="myImg" v-if="bannerUrlMobile && !error.author_banner_mobile.message" :src="bannerUrlMobile"/>
            </CCol>
          </CRow>
            <CRow class="form-group">
            <CCol :col="9">
              <CInputFile
                  label="Profile Picture"
                  horizontal
                  type="file"
                  :isValid="false"
                  :invalidFeedback="error.author_avatar.message"
                  @change="handleCorporateActionAvatar"
              >
               <template v-slot:label-after-input>
                  File size should be below 2MB and Optimize picture size is 140px x 140px.
                </template>
              </CInputFile>
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="9">
              <img class="image-avatar" id="myImg" v-if="avatarUrl && !error.author_avatar.message" :src="avatarUrl"/>
            </CCol>
          </CRow>
           <CRow class="form-group">
            <CCol :col="9">
                <div>Sosial Media</div>
            </CCol>
           </CRow>
           <CRow class="form-group">
            <CCol :col="9">
              <CInput
                  label="Facebook"
                  class=" mb-3"
                  type="text"
                  required
                  horizontal
                  placeholder="Facebook"
                  @change="handleFacebook"
              />
              <CInput
                  label="X"
                  class="mb-3"
                  type="text"
                  required
                  horizontal
                  placeholder="X"
                  @change="handleX"
              />
              <CInput
                  label="LinkedIn"
                  class="mb-3"
                  type="text"
                  required
                  horizontal
                  placeholder="LinkedIn"
                  @change="handleLinkedIn"
              />
            </CCol>
          </CRow> 
          <CRow class="form-group">
            <CCol :col="9">
              <LanguageRadioGroup
                  :horizontal="true"
                  v-model="authorForm.language"
                  name="cms-corporate-author-create-language"
                  id-prefix="cms-corporate-author-create-language"
                  test-id="cms-corporate-author-create-language"
              />
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="9">
              <CSelect
                  label="Status"
                  :options="optionsStatus"
                  required
                  horizontal
                  v-model="authorForm.author_status"
                  @change="handleStatusCorporateAction"
              />
            </CCol>
          </CRow>
        </CCardBody>
        <CCardFooter>
          <CRow>
            <CCol sm="5">
              <CButton color="primary" @click="goBack">Back</CButton>
            </CCol>
            <CCol sm="7" class="d-none d-md-block">
              <CButton
                  color="success"
                  class="float-right"
                  data-testid="cms-corporate-author-create-save"
                  @click="createNewProgram"
              >Save</CButton>
            </CCol>
          </CRow>
        </CCardFooter>
      </CCard>
    </CCol>
  </CRow>
</template>

<script>
// import usersData from './UsersData'
import Swal from "sweetalert2";
import jwt from "jsonwebtoken"
import {validateImageHeightAndWidth} from "./helper";
import LanguageRadioGroup from "../../../components/LanguageRadioGroup.vue";
import { createEmptyAuthorForm } from "./app/types";
import CorporateAuthorUseCase from "./app/usecase";

export default {
  name: "ProgramCreate",
  components: { LanguageRadioGroup },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.usersOpened = from.fullPath.includes("usercreate");
    });
  },
  data() {
    return {
      authorForm: createEmptyAuthorForm(),
      optionsStatus: ["ACTIVE", "INACTIVE"],
      isSubmitting: false,
      error: {
        author_banner: {
          message: ''
        },
        author_avatar: {
          message: ''
        },
        author_banner_mobile: {
          message: ''
        }
      },
      bannerUrl: null,
      bannerUrlMobile: null,
      avatarUrl: null,
    };
  },
  mounted() {
    this.authentication()
  },
  computed: {},
  methods: {
     async checkAuthor(name) {
      const { data: available, err } = await CorporateAuthorUseCase.checkAvailable(
        name,
        this.authorForm.language
      );

      if (err) {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: err,
        });
        return;
      }

      if (available === false) {
        this.authorForm.author_name = "";
        this.authorForm.author_slug = "";
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Author telah tersedia",
        });
      }
    },
    authentication() {
      const data = jwt.decode(localStorage.getItem("token"));
      if (
          data.account_group === "MARKETING" ||
          data.account_group === "ADMIN" ||
          data.account_group === "ADMINISTRATOR"
      ) {
        return null
      } else {
        this.$router.push({path: `/`});
      }
    },
    goBack() {
      this.usersOpened
          ? this.$router.go(-1)
          : this.$router.push({path: "/management/corporate-author"});
    },
    handleCorporateActionTitle(event) {
      var slug = event.replaceAll(/[^A-Za-z0-9 ]/g, '').replaceAll(' ', '-').replaceAll('--', '-').toLowerCase().trim();
      document.getElementById('corporate_slug').value = slug;
      this.authorForm.author_slug = slug;
      this.checkAuthor(event)
      this.authorForm.author_name = event;
    },
    handleCorporateActionSlug(event) {
      var slug = event.replaceAll(/[^A-Za-z0-9 ]/g, '').replaceAll(' ', '-').replaceAll('--', '-').toLowerCase().trim();
      document.getElementById('corporate_slug').value = slug;
      this.authorForm.author_slug = slug;
    },
    handleStatusCorporateAction(event) {
      this.authorForm.author_status = event.target.value;
    },
    async handleCorporateActionBannerUrl(event) {
      const file = event[0];
      const {dataUrl, err} = await validateImageHeightAndWidth(file)
      this.url = dataUrl
      this.bannerUrl = dataUrl
      this.error.author_banner.message = err
      this.authorForm.author_banner = event[0];
    },
    async handleCorporateActionBannerMobileUrl(event) {
      const file = event[0];
      const {dataUrl, err} = await validateImageHeightAndWidth(file, false, true)
      this.url = dataUrl
      this.bannerUrlMobile = dataUrl
      this.error.author_banner_mobile.message = err
      this.authorForm.author_banner_mobile = event[0];
    },
    async handleCorporateActionAvatar(event) {
      const file = event[0];
      const {dataUrl, err} = await validateImageHeightAndWidth(file, true, false)
      this.url = dataUrl
      this.avatarUrl = dataUrl
      this.error.author_avatar.message = err
      this.authorForm.author_avatar = event[0];
    },
    handleAuthorDescription(event) {
      this.authorForm.author_desc = event;
    },
    handleFacebook(event) {
      this.authorForm.author_facebook_url = event;
    },
    handleX(event) {
      this.authorForm.author_x_url = event;
    },
    handleLinkedIn(event) {
      this.authorForm.author_in_url = event;
    },
    async createNewProgram() {
      if (
          this.authorForm.author_banner && this.authorForm.author_avatar && this.authorForm.author_banner_mobile
        ) {
         if (this.authorForm.author_banner['size'] > 2000000 || this.authorForm.author_banner_mobile['size'] > 2000000 || this.authorForm.author_avatar['size'] > 2000000) {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Picture too big. Please upload below 2 MB"
          });
          return;
        }
        if (this.error.author_banner.message || this.error.author_avatar.message || this.error.author_banner_mobile.message) {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: this.error.author_banner.message || this.error.author_avatar.message || this.error.author_banner_mobile.message
          });
          return;
        }
      } else {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Picture harap diisi."
        });
        return;
      }

      this.isSubmitting = true;
      const { err } = await CorporateAuthorUseCase.createOne(this.authorForm);
      this.isSubmitting = false;

      if (err) {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: err
        });
        return;
      }

      Swal.fire({
        icon: "success",
        title: `Author Data Created`,
        showConfirmButton: false,
        timer: 2000
      });
      this.$router.push({path: `/management/corporate-author`});
    },
    validator(val) {
      return val ? val.length >= 4 : false;
    },
  }
};
</script>

<style scoped>
@import "./CorporateAuthor.css";
</style>
